import { defineComponent as r, resolveComponent as l, openBlock as s, createElementBlock as i, createVNode as c } from "vue";
import a from "../VIcon/VIcon.js";
import { _ as p } from "../../../_plugin-vue_export-helper-dad06003.js";
const u = r({
  name: "VIconButton",
  components: { VIcon: a },
  emits: ["click"],
  props: {
    symbol: {
      type: String,
      required: !0
    },
    size: {
      type: [Number, String],
      default: 20
    },
    color: {
      type: String,
      default: "currentColor"
    },
    langCode: {
      type: String,
      default: "de"
    },
    buttonLabel: {
      type: String,
      default: ""
    }
  }
});
const m = ["aria-label", "name"];
function b(o, e, d, _, f, y) {
  const t = l("VIcon");
  return s(), i("button", {
    class: "hobi-icon-button",
    type: "button",
    onClick: e[0] || (e[0] = (n) => o.$emit("click", n)),
    "aria-label": o.buttonLabel,
    name: o.buttonLabel
  }, [
    c(t, {
      symbol: o.symbol,
      color: o.color,
      size: o.size,
      viewBox: "0 0 24 24",
      role: "presentation",
      class: "hobi-icon-button-icon"
    }, null, 8, ["symbol", "color", "size"])
  ], 8, m);
}
const B = /* @__PURE__ */ p(u, [["render", b], ["__scopeId", "data-v-03f512b4"]]);
export {
  B as default
};
